//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'card',
  props: {
    isErrorBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleRemove: function handleRemove() {
      this.$emit('handleRemove');
    },
    dragstart: function dragstart(e) {
      this.$emit('handleDragstart', e);
    },
    dragenter: function dragenter(e) {
      this.$emit('handleDragenter', e);
    }
  }
};